export const OFFER_BUILDING_POLYGON_BASE_COLOR = "#4895ef";
export const PROPERTY_BUILDING_POLYGON_BASE_COLOR = "#f4a261";

export const getOfferBuildingPolygonOptions = (buildingId: number, propertyBuildingId?: number) => {
    const isPropertyBuilding = buildingId === propertyBuildingId;
    const color = isPropertyBuilding ? PROPERTY_BUILDING_POLYGON_BASE_COLOR : OFFER_BUILDING_POLYGON_BASE_COLOR;

    return {
        strokeColor: color,
        fillColor: color,
        strokeWeight: 1,
        fillOpacity: 0.35,
        strokeOpacity: 0.8
    };
};
export const OFFER_BUILDING_POLYGON_BASE_COLOR = "#4895ef";
export const PROPERTY_BUILDING_POLYGON_BASE_COLOR = "#f4a261";

export const getOfferBuildingPolygonOptions = (buildingId: number, propertyBuildingId?: number) => {
    const isPropertyBuilding = buildingId === propertyBuildingId;
    const color = isPropertyBuilding ? PROPERTY_BUILDING_POLYGON_BASE_COLOR : OFFER_BUILDING_POLYGON_BASE_COLOR;

    return {
        strokeColor: color,
        fillColor: color,
        strokeWeight: 1,
        fillOpacity: 0.35,
        strokeOpacity: 0.8
    };
};
